<template>
    <div
      class="custom-dialog"
      :style="dialogStyle"
      @mousedown="startDrag"
    >
      <div class="header" @mousedown.stop="startDrag" :style="{ cursor: 'move' }">
        <slot name="header">默认标题</slot>
        <span class="close-btn" @click="closeDialog">×</span>
      </div>
      <div class="content">
        <slot>默认内容</slot>
      </div>
      <div class="resize-handle" @mousedown.stop="startResize"></div>
    </div>
</template>
  
  <script>
  export default {
    name: "ResizableDialog",
    props: {
      width: {
        type: String,
        default: "400px",
      },
      height: {
        type: String,
        default: "300px",
      },
      top: {
        type: String,
        default: "100px",
      },
      left: {
        type: String,
        default: "100px",
      },
    },
    data() {
      return {
        isDragging: false,
        isResizing: false,
        startX: 0,
        startY: 0,
        initialWidth: 0,
        initialHeight: 0,
        dialogPosition: { top: this.top, left: this.left },
        dialogSize: { width: this.width, height: this.height },
      };
    },
    computed: {
      dialogStyle() {
        return {
          top: this.dialogPosition.top,
          left: this.dialogPosition.left,
          width: this.dialogSize.width,
          height: this.dialogSize.height,
        };
      },
    },
    methods: {
      startDrag(e) {
        this.isDragging = true;
        this.startX = e.clientX - parseInt(this.dialogPosition.left);
        this.startY = e.clientY - parseInt(this.dialogPosition.top);
        document.addEventListener("mousemove", this.onDrag);
        document.addEventListener("mouseup", this.stopDrag);
      },
      onDrag(e) {
        if (!this.isDragging) return;
        this.dialogPosition.left = `${e.clientX - this.startX}px`;
        this.dialogPosition.top = `${e.clientY - this.startY}px`;
      },
      stopDrag() {
        this.isDragging = false;
        document.removeEventListener("mousemove", this.onDrag);
        document.removeEventListener("mouseup", this.stopDrag);
      },
      startResize(e) {
        this.isResizing = true;
        this.startX = e.clientX;
        this.startY = e.clientY;
        this.initialWidth = parseInt(this.dialogSize.width);
        this.initialHeight = parseInt(this.dialogSize.height);
        document.addEventListener("mousemove", this.onResize);
        document.addEventListener("mouseup", this.stopResize);
      },
      onResize(e) {
        if (!this.isResizing) return;
        this.dialogSize.width = `${this.initialWidth + e.clientX - this.startX}px`;
        this.dialogSize.height = `${this.initialHeight + e.clientY - this.startY}px`;
      },
      stopResize() {
        this.isResizing = false;
        document.removeEventListener("mousemove", this.onResize);
        document.removeEventListener("mouseup", this.stopResize);
      },
      closeDialog() {
        this.$emit("close");
      },
    },
  };
  </script>
  
  <style scoped>
  .custom-dialog {
    position: absolute;
    border: 1px solid #ccc;
    background-color: white;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    overflow: hidden;
  }
  .header {
    background: #f5f5f5;
    padding: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .close-btn {
    cursor: pointer;
    font-size: 18px;
  }
  .content {
    padding: 10px;
  }
  .resize-handle {
    width: 10px;
    height: 10px;
    background: #ccc;
    position: absolute;
    bottom: 0;
    right: 0;
    cursor: se-resize;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/ResizableDialog/ResizableDialog.vue